import {
  Outlet, 
  Link,
  useLocation,
  NavLink
} from "react-router-dom";
import React, {
  Suspense, useEffect,
} from 'react';
import { 
  useNavigate, 
  // useSearchParams,
} from "react-router-dom";


import { useAuth } from "react-oidc-context";

import { useState } from 'react'



import { useDispatch, useSelector } from "react-redux";

import SetUpRequired from "./SetUpRequired";

import DigitalWorkerLayout from "../../utils/DigitalWorkerLayout";



const pageVariants = {
  initial: {
    opacity: 0
  },
  in: {
    opacity: 1
  },
  out: {
    opacity: 0
  }
};

const pageTransition = {
  type: "tween",
  ease: "linear",
  duration: 0.15
};


function Layout() {

  const auth = useAuth();

  const location = useLocation()

  const navigate = useNavigate()

  const [colorChange, setColorchange] = useState(false);

  const role = useSelector((state) => state.step.role)

  const allSteps = useSelector((state) => state.step.steps[state.step.role])

  const dispatch = useDispatch()

  let navChangedColorHeight;

  if(location.pathname == '/'){
    navChangedColorHeight = window.innerHeight
  }else{
    navChangedColorHeight = window.innerHeight/2
  }

  const changeNavbarColor = (scrollTop) =>{
      if(scrollTop>0){
        setColorchange(true);
      }
      else{
        setColorchange(false);
      }
  };

  let scroller = document.querySelector("#scroller")
  scroller?.addEventListener("scroll", (event) => {
    changeNavbarColor(scroller.scrollTop)
  });


  return (
    <SetUpRequired>
      {/* <MenuBar /> */}


        <DigitalWorkerLayout tabs={[
          {
            name: 'Documents',
            routeInclude: 'documents',
            onClick: () => {navigate('/mydigitalworkers/atlas/documents')}
          },
          {
            name: 'Folder Structure',
            routeInclude: 'structure',
            onClick: () => {navigate('/mydigitalworkers/atlas/structure')}
          }
        ]}
        digitalWorkerName={'Atlas'} digitalWorkerDescription={'Professional Document Organizer'}/>

    </SetUpRequired>
  )
}

export default Layout;